var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sticky-starter-nav", class: _vm.componentClasses },
    [
      _c("div", { staticClass: "sticky-starter-nav__content" }, [
        _c(
          "div",
          {
            staticClass: "sticky-starter-nav__main-content",
            class: _vm.mainContentClasses
          },
          [
            _vm.isSocialShareEnabled
              ? _c(
                  "div",
                  { staticClass: "sticky-starter-nav__share-button-container" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "sticky-starter-nav__share-button",
                        on: {
                          click: function($event) {
                            return _vm.shareButtonClicked()
                          }
                        }
                      },
                      [_vm._v("\n          Share\n        ")]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("default")
          ],
          2
        ),
        _vm._v(" "),
        _vm.isSocialShareEnabled
          ? _c(
              "div",
              { staticClass: "sticky-starter-nav__social-content" },
              [
                _c(
                  "button",
                  {
                    staticClass: "sticky-starter-nav__back-button",
                    on: {
                      click: function($event) {
                        return _vm.backButtonClicked()
                      }
                    }
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "10",
                          height: "16",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            "stroke-width": "2.4",
                            d: "M8 2L2 8.164627 8 14",
                            stroke: "currentColor",
                            fill: "none",
                            "fill-rule": "evenodd",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.socialShareModel.social_links, function(socialLink) {
                  return _c("a", {
                    key: socialLink.key,
                    staticClass: "sticky-starter-nav__social-link",
                    attrs: { href: socialLink.url },
                    domProps: { innerHTML: _vm._s(socialLink.icon) },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.socialLinkClicked(socialLink)
                      }
                    }
                  })
                }),
                _vm._v(" "),
                _c("div")
              ],
              2
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }